export default __webpack_public_path__ + "static/media/undraw_connected_world_wuay.9bfc26c6.png";